import axios from 'axios';
import config from '../config';
import { handlingSession, sessionID } from './../../utils/handlingSession';
import { userLogs } from './../logs/userLogs';

export const getHolidayPeriod = async (formData) => {
    try {
        let url = config.hummBackendAppURL + 'contract/get-holiday-period';
        const res = await axios.post(url, formData, { headers: sessionID() });
        return res;
    } catch (err) {
        let url = config.hummBackendAppURL + 'contract/get-holiday-period';
        await userLogs(url, formData, err);
        if (err.response) {
            handlingSession(err.response.status);
        }
        return err.response;
    }
}; 